import { render, staticRenderFns } from "./CustomSelectsArrOfIconObj.vue?vue&type=template&id=f5c8ba80&"
import script from "./CustomSelectsArrOfIconObj.vue?vue&type=script&lang=js&"
export * from "./CustomSelectsArrOfIconObj.vue?vue&type=script&lang=js&"
import style0 from "./CustomSelectsArrOfIconObj.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VIcon,VRow,VSelect})
